/**
 * 24개 계측 타입별 아이콘 매핑
 *
 * MeasureTypeSelector, MeasureTab 등에서 공통으로 사용
 * DRY 원칙에 따라 한 곳에서 관리
 */
import type { MeasureTypeKeyType } from "@ict/shared";
import {
  PlugZap,
  Battery,
  Anchor,
  Cable,
  BatteryCharging,
  BatteryFull,
  Clock,
  Network,
  Sun,
  Send,
  BarChart3,
  ArrowLeftRight,
  TowerControl,
  Music,
  Satellite,
  BellRing,
  Gauge,
  Unplug,
  Signal,
  Compass,
  Ruler,
  Thermometer,
  FlaskRound,
  Wind,
} from "lucide-react";

/** 24개 계측 타입별 개별 아이콘 매핑 */
export const measureTypeIcons: Record<
  MeasureTypeKeyType,
  React.ComponentType<{ className?: string }>
> = {
  // 전기 (7개)
  acVoltage: PlugZap,
  dcVoltage: Battery,
  groundResistance: Anchor,
  terminationResistance: Cable,
  chargingVoltageCurrent: BatteryCharging,
  batteryVoltage: BatteryFull,
  clockLineVoltage: Clock,
  // 통신환경 (5개)
  linkSpeed: Network,
  opticalLevel: Sun,
  txOutput: Send,
  outputTerminalLevel: BarChart3,
  ioSignalLevel: ArrowLeftRight,
  // 전파환경 (3개)
  rsrpTerrestrial: TowerControl,
  rsrpFmRadio: Music,
  rsrpSatellite: Satellite,
  // 무선신호 (2개)
  emergencyBellSensitivity: BellRing,
  remoteMeteringSensitivity: Gauge,
  // 전계강도 (2개)
  coaxialFieldStrength: Unplug,
  wirelessFieldStrength: Signal,
  // RF카드 (2개)
  rfMagneticField: Compass,
  rfRecognitionDistance: Ruler,
  // 기타 (3개)
  temperatureHumidity: Thermometer,
  batterySpecificGravity: FlaskRound,
  manholeToxicGas: Wind,
};
